import { IApplicationState } from '../../types/redux';

export function getMeta(state: IApplicationState) {
  const { tab } = state;

  return state[tab].listing.meta;
}
